import axios from 'axios'

const service = async (method, url, data) => {
  try {
    const res = await axios({
      method,
      url: `${process.env.REACT_APP_API}/v1${url}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data ? data : null,
    })

    if (res.data.emailWarning) {
      console.log(res.data.emailWarning)
      return res.data
    }

    return res.data || true
  } catch (error) {
    if (error.response) {
      if (error.response.status === 500) {
        console.log('Erro interno no servidor. Tente novamente mais tarde.')
      } else {
        console.log(error.response.data.error)
      }
    } else {
      console.log('Houve um erro ao realizar esta ação')
    }

    return false
  }
}

export const get = ({ url }) => {
  return service('GET', url)
}

export const post = ({ url, data }) => {
  return service('POST', url, data)
}
